import { render, staticRenderFns } from "./damageMobilierCategory2.pug?vue&type=template&id=a602c816&lang=pug&external"
import script from "./damageMobilierCategory2.js?vue&type=script&lang=js&external"
export * from "./damageMobilierCategory2.js?vue&type=script&lang=js&external"
import style0 from "./damageMobilierCategory2.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a602c816')) {
      api.createRecord('a602c816', component.options)
    } else {
      api.reload('a602c816', component.options)
    }
    module.hot.accept("./damageMobilierCategory2.pug?vue&type=template&id=a602c816&lang=pug&external", function () {
      api.rerender('a602c816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/damageMobilierCategory2/index.vue"
export default component.exports